<template>
  <div class="list-container">
    <!-- Desktop -->
    <div class="desktop-only">
      <base-table 
        :columns="columns" 
        :data="data" 
        :actions="actions" 
        :actionClass="actionClass" 
        :headerActitonStyle="headerActitonStyle"
        :actionStyle="actionStyle" 
        @loadMore="$emit('loadMore')">
        
        <template v-for="col in columns" v-slot:[`col-${col.key}`]="slotProps">
          <slot :name="`col-${col.key}`" v-bind="slotProps" />
        </template>

      </base-table>
    </div>

    <!-- Mobile -->
    <div class="mobile-only">
      <base-card :columns="columns" :data="data" :actions="actions" :actionClass="actionClass"
        :actionStyle="actionStyle" :titleKey="titleKey" @loadMore="$emit('loadMore')">
        <template v-for="col in columns" v-slot:[`col-${col.key}`]="slotProps">
          <slot :name="`col-${col.key}`" v-bind="slotProps" />
        </template>
      </base-card>
    </div>
  </div>
</template>

<script>
import BaseTable from './BaseTable.vue';
import BaseCard from './BaseCard.vue';

export default {
  name: 'ListContainer',
  components: { BaseTable, BaseCard },
  props: {
    columns: { type: Array, required: true },
    data: { type: Array, required: true },
    actions: { type: Array, default: () => [] },
    actionClass: { type: String, default: null },
    actionStyle: { type: String, default: null },
    titleKey: { type: String, required: true },
    headerActitonStyle:{ type:[String, Object, Array], default: () => ({})}
  }
};
</script>

<style>
.list-container {
  width: 100%;
}

/* Desktop visible por defecto */
.desktop-only {
  display: block;
}

.mobile-only {
  display: none;
}

/* Mobile visible en pantallas pequeñas */
@media (max-width: 768px) {
  .desktop-only {
    display: none;
  }

  .mobile-only {
    display: block;
  }
}
</style>